import React from "react";
import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import DetailsPage from "components/pet-details/DetailsPage";
import UserHeroSection from "components/user/UserHeroSection";
import UserAuth from "components/AuthGaurd/UserAuth";

type Props = {};

export default function PetDetails({}: Props) {
  return (
    <UserAuth>
      <div className="tw-relative tw-w-screen tw-h-screen">
        <header>
          <Header />
        </header>
        <UserHeroSection title="My Pets">
          <DetailsPage />
        </UserHeroSection>
        <footer className="tw-block">
          <Footer />
        </footer>
      </div>
    </UserAuth>
  );
}
